export default "__VITE_ASSET__C6O_5X5Q__"